import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IBatchesParametersFormMeta {
  tableName: FormInputMeta;
  batchStartTime: FormInputMeta;
  batchEndTime: FormInputMeta;
  purgedDays: FormInputMeta;
  purgedRecord: FormInputMeta;
  purgedSince: FormInputMeta;
  businessDate: FormInputMeta;
  status: FormInputMeta;

  schema: any;
}

const batchesParametersFormMeta = {} as IBatchesParametersFormMeta;

batchesParametersFormMeta.tableName = {
  name: "tableName",
  type: "text",
  label: "Table Name",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire"),
};

batchesParametersFormMeta.batchStartTime = {
  name: "batchStartTime",
  type: "date",
  label: "Batch Start Time",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire"),
};

batchesParametersFormMeta.batchEndTime = {
  name: "batchEndTime",
  type: "text",
  label: "Batch end time",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire"),
};

batchesParametersFormMeta.purgedDays = {
  name: "purgedDays",
  type: "date",
  label: "Purged Days",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire"),
};

batchesParametersFormMeta.purgedRecord = {
  name: "purgedRecord",
  type: "text",
  label: "Purged Record",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire"),
};

batchesParametersFormMeta.purgedSince = {
  name: "purgedSince",
  type: "date",
  label: "Purged Since",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire"),
};

batchesParametersFormMeta.businessDate = {
  name: "businessDate",
  type: "date",
  label: "Business Date",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire"),
};

batchesParametersFormMeta.status = {
  name: "status",
  type: "select",
  label: "Status",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire"),
};

batchesParametersFormMeta.schema = yup.object().shape(getValidationSchema(batchesParametersFormMeta));
 
export default batchesParametersFormMeta;